import React from "react";
import { makeStyles } from "@material-ui/core";

export default function AspectRatio({
  w = 1,
  h = 1,
  width = "100%",
  children,
  ...props
}) {
  const useStyles = makeStyles({
    crust: {
      width,
    },
    letter: {
      position: "relative",
      width: "100%",
      paddingTop: `${(h / w) * 100}%`,
    },
    core: {
      width: "100%",
      height: "100%",
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
    },
  });
  const classes = useStyles();
  return (
    <div className={classes.crust} {...props}>
      <div className={classes.letter}>
        <div className={classes.core}>{children}</div>
      </div>
    </div>
  );
}
